//
// Inputs styles
//
export const disableInput = {
    backgroundColor: '#f7f9fa',
    border: '2px #c6cfd7 solid'
};

export const errorInput = {
    border: '1px solid #f44336',
    borderRadius: '8px'
};
